"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractStartEnd = void 0;
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const ContractStartEnd = ({ contractEnds, contractStarts, day, }) => {
    const workspace = (0, store_1.useRootSelector)(state => state.workspaces.find(ws => ws.id === state.workspaceId));
    const contractStart = contractStarts[day];
    const contractEnd = contractEnds[day];
    if ((0, util_1.isUndefined)(contractStart) && (0, util_1.isUndefined)(contractEnd))
        return null;
    const isEnd = (0, util_1.isDefined)(contractEnd) && (0, util_1.isNotNull)(contractEnd);
    const currentContract = contractEnd ?? contractStart;
    const contractName = workspace?.contractTypes?.find(ct => ct.id === currentContract.type)?.name;
    const contractHours = util_1.numberUtil.round2decimals((currentContract.minutes ?? 0) / 60);
    return (react_1.default.createElement("div", { className: `ds-c-col-contract-${isEnd ? 'end' : 'start'}` },
        react_1.default.createElement("span", null, contractName),
        (0, util_1.isDefined)(currentContract.minutes) ? react_1.default.createElement("span", null,
            "(",
            contractHours,
            ")") : null,
        react_1.default.createElement("div", { className: `contr-${isEnd ? 'end' : 'start'}-border` })));
};
exports.ContractStartEnd = ContractStartEnd;
